import io from "socket.io-client";

export const getSocketAccessToken = () => {
  const storedToken = localStorage.getItem("token");
  if (!storedToken) return "";

  try {
    const parsedToken = JSON.parse(storedToken);
    return typeof parsedToken === "string" ? parsedToken : "";
  } catch (_) {
    return storedToken;
  }
};

class SocketWorker {
  constructor(companyId , userId) {
    if (SocketWorker.instance && (
      String(SocketWorker.instance.companyId) !== String(companyId) ||
      String(SocketWorker.instance.userId) !== String(userId)
    )) {
      SocketWorker.instance.disconnect();
    }
    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.socket = null;
      this.shouldReconnect = true;
      this.reconnectTimer = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      auth: callback => {
        const token = getSocketAccessToken();
        callback(token ? { token } : {});
      },
      query: { userId: String(this.userId) }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
    this.socket.on("connect_error", () => this.reconnectAfterDelay());
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    if (!this.socket) return;
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    this.shouldReconnect = false;
    clearTimeout(this.reconnectTimer);
    this.reconnectTimer = null;
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      if (SocketWorker.instance === this) SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    if (!this.shouldReconnect || this.reconnectTimer) return;
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      if (this.shouldReconnect && this.socket && !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.socket.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket && this.shouldReconnect) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
